"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.defaultContext = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _stitches = require("./stitches.config");

const defaultContext = {
  isDark: false,
  theme: _stitches.theme,
  type: 'light'
};
exports.defaultContext = defaultContext;

const ThemeContext = /*#__PURE__*/_react.default.createContext(defaultContext);

var _default = ThemeContext;
exports.default = _default;